/**
 * Configuration file for AI players
 * Each player defines:
 * - id: unique identifier
 * - name: display name
 * - level: AI difficulty level ('beginner', 'intermediate', 'expert')
 * - thumbnail: image filename in the ai_players folder
 * - description: brief description of the player
 */

// Dynamic list populated from backend players.php
export const aiPlayersConfig = [];

/**
 * Get all AI players
 * @returns {Array} Array of all AI player configurations
 */
export const getAllAIPlayers = () => {
  return aiPlayersConfig;
};

// Fetch players from backend and populate config array
export const fetchAIPlayers = async () => {
  try {
    // Dynamic base: dev (port 3000) -> backend on 8000; prod -> relative
    const base = (typeof window !== 'undefined' && window.location && window.location.port === '3000')
      ? 'http://localhost:8000/'
      : '';
    // Bypass caches to ensure latest list (pairs with no-cache headers server-side)
    const res = await fetch(base + 'players.php', { cache: 'no-store' });
    const json = await res.json();
    if (json && json.success && Array.isArray(json.players)) {
      aiPlayersConfig.splice(0, aiPlayersConfig.length, ...json.players);
    }
  } catch (_) {}
  return aiPlayersConfig;
};

/**
 * Get AI players by level
 * @param {string} level - The difficulty level ('beginner', 'intermediate', 'expert')
 * @returns {Array} Array of AI players with the specified level
 */
export const getAIPlayersByLevel = (_level) => {
  // Legacy no-op: levels removed. Return all.
  return aiPlayersConfig;
};

/**
 * Get AI player by ID
 * @param {string} id - The player ID
 * @returns {Object|null} The AI player configuration or null if not found
 */
export const getAIPlayerById = (id) => {
  return aiPlayersConfig.find(player => player.id === id) || null;
};

/**
 * Get AI players grouped by level
 * @returns {Object} Object with levels as keys and arrays of players as values
 */
export const getAIPlayersGroupedByLevel = () => {
  // Legacy no-op: return single bucket of all players
  return { all: [...aiPlayersConfig] };
};
